export default __webpack_public_path__ + "static/media/doctor-2.4ca02f46.jpg";